module.exports = __webpack_public_path__ + "static/bg-6399e56c55476f951cba8195b0904043.jpg";